import { Table } from 'reactstrap';
import { useState, useEffect } from 'react'
import { useSelector, connect } from "react-redux"
import Pagination from './parts/Pagination'
import OrderSummary from './parts/OrderSummary'
import Contact from './parts/Contact'
import CustomizationSummary from './parts/CustomizationSummary'
import PauseControl from './parts/PauseControl'
import RetailProControl from './parts/RetailProControl'
import { formatDate } from './parts/helperFunctions'
import { FaSort, FaDownload } from "react-icons/fa";
import './Inbound.scss';

const endpoint = process.env.REACT_APP_API_ENDPOINT


const mapStateToProps = (state) => ({
  orders: state.console.orders,
})

function Inbound(props) {

	const products = useSelector(state => state.product.balls)
	const adminGroupIndex = useSelector(state => state.app.adminGroup)

	var orders = props.orders
				   .filter(p => (p.Status === 'INBOUND' || p.Status === 'RISKIFIED_DECLINED') && (p.Paused === false) && (p.BamboraPreAuth.Type === 'PAC'))

	const [retailProNums, setRetailProNums] = useState({})
	const [dateSortForward, setDateSortForward] = useState(true)
	const [sortedOrders, setSortedOrders] = useState([])

	const sortOrders = () => {
		setSortedOrders ( orders.sort(function(a, b) {
		    var c = new Date(a.Updated);
		    var d = new Date(b.Updated);
		    return dateSortForward ? c-d : d-c;
		}) )
	}

	useEffect(()=>{
		sortOrders()
	},[dateSortForward, orders.length])

	return (
		adminGroupIndex < 2
		? <div className="dashboard-inbound">

	    	<div className="tab-description mt-3">
	    		<h6>This tab is for use by Golf Town Promotions.</h6>
					<p>Enter and save Retail Pro order number for each inbound order to move it into the Production Queue for fulfillment.</p>
				</div>

			<Table className="inbound-table" responsive striped >
			  <thead>
			    <tr>
			      <th className='sortable' onClick={()=>{setDateSortForward(!dateSortForward)}}>
			        Date <FaSort className='icons' />
			      </th>
			      <th>
			        Summary
			      </th>
			      <th>
			        Shipping
			      </th>
			      <th>
			        Product
			      </th>
			      <th>
			        Customizations
			      </th>
			      <th>
			        Retail Pro #
			      </th>
			    </tr>
			  </thead>

			  <tbody>
			  { sortedOrders.map((orderObj) => {

		  		const product = products.filter(product => product.ID === orderObj.ProductID)[0]

		  		return (
				    <tr key={orderObj.ID}>
				      <td className="col-1">
				        {formatDate(orderObj.Updated)}
				      </td>
				      <td className="col-2">
				        <OrderSummary orderObj={orderObj} context="INBOUND" />
				      </td>
				      <td className="col-3">
				      	<p><span className='contact-label'>Shipping:</span><br /><Contact contactObj={orderObj.Billing.ShippingAddress} context="INBOUND" /></p>
				      	<p><span className='contact-label'>Billing:</span><br /><Contact contactObj={orderObj.Billing.BillingAddress} context="INBOUND" /></p>
				      </td>
				      <td className="col-1">
				        <p>
					        <b>{product.BrandName} {product.NameEN}</b>
						</p>
				      </td>
				      <td className="col-1">
				      	<CustomizationSummary orderObj={orderObj} product={product} context="INBOUND" />
				      </td>
				      <td className="col-2">
						<RetailProControl orderObj={orderObj}/>
						<div className='mt-2'>
							<PauseControl orderObj={orderObj} context='INBOUND'/>
						</div>
				      </td>
				    </tr>

					) })
			  }
			  </tbody>
			</Table>

			<Pagination />
		</div>
		: <div>
	    	<div className="tab-description mt-3">
	    		<h6>This tab is for use by Golf Town Promotions.</h6>
				</div>
		</div>
	)
	
}

export default connect(mapStateToProps)(Inbound)